import { PageHeroBackgroundColor } from './PageHero.types';

export const backgroundColorMap = {
  technology: 'bg-blue-1000',
  logistics: 'bg-yellow-900',
  manufacturing: 'bg-gray-950',
  professionalServices: 'bg-salmon-950',
  financialServices: 'bg-green-900',
  travel: 'bg-pink-900',
  green: 'bg-green-900',
  violet: 'bg-violet-900',
  pink: 'bg-pink-900',
} as const satisfies Record<PageHeroBackgroundColor, string>;
